"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * A block of preformatted output: a recorded log, or a stack trace.
 *
 * One style for both, because they are the same object — lines in the order
 * the process emitted them, scrolling inside themselves so a long one never
 * pushes the rest of the page away.
 */
const styles = exports.styles = {
  logBlock: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x1iah58g",
    rowGap: null,
    columnGap: null,
    padding: "x79iv2k",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    marginBottom: "x1t84w78",
    maxHeight: "xkch13f",
    overflowY: "x1odjw0f",
    overflowX: "xw2csxc",
    backgroundColor: "xkjg22i",
    borderRadius: "x1pq0x4f",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    $$css: true
  },
  logLine: {
    fontFamily: "xm3uy08",
    fontSize: "x9bimuu",
    color: "x10kmngs",
    whiteSpace: "x126k92a",
    wordBreak: "x13faqbe",
    $$css: true
  },
  logTime: {
    color: "xcdm7ny",
    $$css: true
  },
  logLevel: {
    fontWeight: "x1s688f",
    $$css: true
  }
};